.kd{color:var(--gray-900);}